var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.823 57.607 48.4 72.948a1.5 1.5 0 0 0 1.5 0l26.57-15.341a1.5 1.5 0 0 0 .75-1.3v-30.68a1.5 1.5 0 0 0-.75-1.3L49.9 8.988a1.5 1.5 0 0 0-1.5 0L21.823 24.329a1.5 1.5 0 0 0-.75 1.3v30.68a1.5 1.5 0 0 0 .75 1.298Zm2.25-30.014L47.645 41.2v27.851L24.073 55.442Zm26.572 41.458V41.2l23.57-13.608v27.85Zm-1.5-57.032 23.023 13.293L49.145 38.6 26.12 25.312Zm31.26 72.118h-25.04a5.569 5.569 0 0 0-10.73 0H19.6a1.5 1.5 0 0 0 0 3h25.04a5.569 5.569 0 0 0 10.73 0h25.04a1.5 1.5 0 0 0 0-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.02cf56c1a55230fc59502bb693c2fe48.svg";
export { ForwardRef as ReactComponent };